import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomButton from "src/components/CustomButton";
import { GET_MUST_DO_THINGS, GET_MUST_DO_THINGS_ID } from "src/graphql/query";
import {
  Box,
  Checkbox,
  debounce,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  Select,
  Tabs,
  Tab,
} from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import ActionMenu from "../Business/ActionMenu";
import { getRole, hasPermissionPage } from "src/components/Common/Utils";
import CustomTable from "src/components/CustomTable";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteModel from "src/components/Common/DeleteModel";
import { DELETE_MUST_DO_THINGS } from "src/graphql/mutations";
import { toast } from "react-toastify";
import Loader from "src/components/Loader";
import ErrorComponent from "src/components/ErrorComponent";
import moment from "moment";
import MustDoThingsModal from "./MustDoThingsModal";
import MustDoDetailPage from "./MustDoDetailPage";

interface MustDoThings {
  _id: string;
  type: string;
  // Add other necessary fields
}

interface MustDoThingsData {
  type: string;
  data: MustDoThings[];
}

const MustDoThings: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [openDeleteMultipleModel, setOpenDeleteMultipleModel] = useState<boolean>(false);
  const [openDeleteAllModel, setOpenDeleteAllModel] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 50 });
  const [total, setTotal] = useState(0);
  const [list, setList] = useState<MustDoThings[]>([]);
  const [mustDoThingsData, setMustDoThingsData] = useState<MustDoThingsData[]>([]);
  const [selectedMustDoThings, setSelectedMustDoThings] = useState<MustDoThings | null>(null);
  const [isEditMustDoThings, setIsEditMustDoThings] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);
  const [deleteMustDoThing] = useMutation(DELETE_MUST_DO_THINGS);
  const isSuperAdmin = getRole() === "SuperAdmin";
  const initialMustDoThingsObj = {
    _id: "",
  };
  const [mustDoThingsObj, setMustDoThingsObj] = useState<any>(initialMustDoThingsObj);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [currentMustDoThings, setCurrentMustDoThings] = useState<any>(null);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [tabValue, setTabValue] = useState<"ALL" | "MUSTDOTHINGS" | "OTHERS">("ALL");



  const COLUMNS = [
    {
      headerName: "Updated Date",
      field: "updatedAt",
      width: 120,
      renderCell: ({ row }: any) => {
        const date = new Date(row?.updatedAt);
        const day = String(date.getDate()).padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" }); // Apr
        const year = date.getFullYear();
        return <>{`${day}, ${month} ${year}`}</>;
      },
    },
    {
      headerName: "Title",
      field: "title",
      flex: 1,
      renderCell: ({ row }: any) => (
        <>
          <Box sx={{ cursor: "pointer" }} onClick={() => handleView(row)}>
            <Typography variant="body2" fontWeight={500}>
              {row?.title}
            </Typography>
          </Box>
        </>
      ),
    },
    { headerName: "Type", field: "type", flex: 1 },
    { headerName: "Description", field: "description", width: 250 },
    {
      headerName: "Actions",
      flex: 1,
      renderCell: ({ row }: { row: MustDoThings }) => (
        <div>
          {hasPermissionPage("MustDoThings", "update") && (
            <Tooltip title="Edit">
              <IconButton
                onClick={() => handleEdit(row)}
                aria-label="edit"
                style={{ marginRight: "8px", color: "#00C5B9" }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
          {hasPermissionPage("MustDoThings", "delete") && (
            <Tooltip title="Delete">
              <IconButton
                onClick={() => handleDelete(row)}
                aria-label="delete"
                style={{ color: "#00C5B9" }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  const { loading, error, data, refetch } = useQuery(GET_MUST_DO_THINGS, {
    variables: {
      page: pagination.page,
      limit: pagination.pageSize,
    },
  });

  // useEffect(() => {
  //   if (data?.getMustDoThings?.data) {
  //     setMustDoThingsData(data?.getMustDoThings?.data);

  //     // Set the initial list based on the default tab
  //     const initialData = data?.getMustDoThings?.data.find(
  //       (item: MustDoThingsData) => item.type === tabValue
  //     );
  //     setList(initialData?.data || []);
  //     setTotal(initialData?.data?.length || 0);
  //   }
  // }, [data, tabValue]);
  useEffect(() => {
    if (data?.getMustDoThings?.data) {
      setMustDoThingsData(data?.getMustDoThings?.data);

      if (tabValue === "ALL") {
        // Combine all data when "ALL" tab is selected
        const allData = data.getMustDoThings.data.reduce((acc: MustDoThings[], item: MustDoThingsData) => {
          return [...acc, ...item.data];
        }, []);
        setList(allData);
        setTotal(allData.length);
      } else {
        // Filter data based on tabValue
        const selectedData = data.getMustDoThings.data.find(
          (item: MustDoThingsData) => item.type === tabValue
        );
        setList(selectedData?.data || []);
        setTotal(selectedData?.data?.length || 0);
      }
    }
  }, [data, tabValue]);

  // const handleTabChange = (event: React.SyntheticEvent, newValue: "MUSTDOTHINGS" | "OTHERS") => {
  //   setTabValue(newValue);

  //   // Update the list based on the selected tab
  //   const selectedData = mustDoThingsData.find(
  //     (item) => item.type === newValue
  //   );
  //   setList(selectedData?.data || []);
  //   setTotal(selectedData?.data?.length || 0);
  //   setPagination((prev) => ({ ...prev, page: 1 })); // Reset to first page
  // };

  const handleTabChange = (event: React.SyntheticEvent, newValue: "ALL" | "MUSTDOTHINGS" | "OTHERS") => {
    setTabValue(newValue);
    setPagination((prev) => ({ ...prev, page: 1 })); // Reset to first page
  };


  const debouncedRefetch = useCallback(
    debounce((term: string) => {
      setSearchTerm(term.length > 0 ? term : "");
      refetch({
        search: term,
        page: pagination.page,
        limit: pagination.pageSize,
      });
    }, 1000),
    [refetch, pagination.page, pagination.pageSize]
  );

  const [getMustDoThing] = useLazyQuery(GET_MUST_DO_THINGS_ID);

  const handleView = async (deal: { _id: string }) => {
    try {
      const response = await getMustDoThing({ variables: { _id: deal._id } });
      setMustDoThingsObj(response.data?.getMustDoThing?.data);
      setOpenViewModal(true);
    } catch (err) {
      console.error("Error fetching MustDoThings data:", err);
    }
  };



  const handleEdit = async (rowData: any) => {
    try {
      if (!rowData?._id) {
        toast.error("Invalid row data");
        console.error("Invalid row data");
        return;
      }

      const res = await getMustDoThing({
        variables: {
          _id: rowData._id,
        },
      });

      if (res?.data?.getMustDoThing?.statusCode === 200) {
        const removeTypename = (obj: any): any => {
          if (Array.isArray(obj)) {
            return obj.map(removeTypename);
          } else if (typeof obj === "object" && obj !== null) {
            return Object.keys(obj).reduce((acc, key) => {
              if (key !== "__typename") {
                acc[key] = removeTypename(obj[key]);
              }
              return acc;
            }, {} as any);
          }
          return obj;
        };

        const mustDoThingsData = removeTypename(res?.data?.getMustDoThing?.data);
        setMustDoThingsObj(mustDoThingsData);

        // const { __typename, ...MustDoThings } = res?.data?.getCampaign.data;
        // setMustDoThingsObj(MustDoThings);
        setOpenModal(true);
        setIsEditMustDoThings(true);
      } else {
        toast.error("Failed to fetch MustDoThings details");
        console.error("Failed to fetch MustDoThings details");
      }
    } catch (error: any) {
      toast.error(error?.message);
      console.error(
        "An error occurred while fetching MustDoThings details:",
        error
      );
    }
  };

  const handleDelete = (rowData: MustDoThings) => {
    setSelectedMustDoThings(rowData);
    setOpenConfirmDialog(true);
  };
  const confirmDelete = async () => {
    try {
      if (selectedMustDoThings && selectedMustDoThings?._id) {
        const res = await deleteMustDoThing({
          variables: {
            _id: selectedMustDoThings._id,
          },
        });
        if (res?.data?.deleteMustDoThing?.statusCode === 200) {
          toast.success(
            res?.data?.deleteMustDoThing?.message ||
            "MustDoThings deleted successfully!"
          );
          refetch();
        } else {
          throw new Error(res?.data?.deleteMustDoThing?.message);
        }
      }
    } catch (error: any) {
      toast.error(
        error?.message || "An error occurred while deleting the MustDoThings."
      );
    } finally {
      setOpenConfirmDialog(false);
      setSelectedMustDoThings(null);
    }
  };
  const handleCloseModal = () => {
    setMustDoThingsObj(null);
    setOpenModal(false);
    setIsEditMustDoThings(false);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    setPagination((prev) => ({ ...prev, page: 1 }));
    debouncedRefetch(value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setPagination((prev) => ({ ...prev, page: 1 }));
    refetch({ search: "", page: 1, limit: pagination.pageSize });
  };

  const handlePageChange = (newPage: number) => {
    setPagination((prev) => ({ ...prev, page: newPage + 1 }));
    refetch({
      search: searchTerm,
      page: newPage + 1,
      limit: pagination.pageSize,
    });
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPagination((prev) => ({ ...prev, pageSize: newPageSize }));
    refetch({
      search: searchTerm,
      page: pagination.page,
      limit: newPageSize,
    });
  };


  if (openViewModal) {
    return (
      <MustDoDetailPage
        mustDoThingsObj={mustDoThingsObj}
        handleClose={() => setOpenViewModal(false)}
        refetchMustDoThings={function (): void {
          throw new Error("Function not implemented.");
        }} />
    );
  }

  if (loading) return <Loader />;
  if (error) return <ErrorComponent />;


  return (
    <>
      <Box p={2}>
        {!openModal && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              paddingRight={4}
            >
              <Typography variant="h4" style={{ color: "#00C5B9" }}>
                Must Do Things
              </Typography>
              <Box display="flex" alignItems="center" gap={2}>
                <Box width={200}>
                  <TextField
                    label="Search"
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                      endAdornment: searchTerm && (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClearSearch}>
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                {isSuperAdmin && (
                  <ActionMenu
                    isSuperAdmin={isSuperAdmin}
                    setOpenDeleteMultipleModel={setOpenDeleteMultipleModel}
                    setOpenDeleteAllModel={setOpenDeleteAllModel}
                  />
                )}
                {hasPermissionPage("MustDoThings", "add") && (
                  <Box>
                    <CustomButton
                      // onClick={() => setOpenModal(true)}
                      onClick={() => {
                        setMustDoThingsObj(null);
                        setIsEditMustDoThings(false);
                        setOpenModal(true);
                      }}
                      variant="contained"
                      className="width: 200px"
                    >
                      Create
                    </CustomButton>
                  </Box>
                )}
                <Box></Box>
              </Box>
            </Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
              <Tabs value={tabValue} onChange={handleTabChange}>
                <Tab label="All" value="ALL" />
                <Tab label="Must Do Things" value="MUSTDOTHINGS" />
                <Tab label="Others" value="OTHERS" />
              </Tabs>
            </Box>

            <Box mt={2}>
              <CustomTable
                columns={COLUMNS}
                data={list}
                paginationModel={{
                  page: pagination.page - 1,
                  pageSize: pagination.pageSize,
                }}
                totalCount={total}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
              />
            </Box>
          </>
        )}
        {openModal && (
          <MustDoThingsModal
            handleClose={handleCloseModal}
            refetchMustDoThings={() => refetch()}
            initialMustDoThingsObj={initialMustDoThingsObj}
            mustDoThingsObj={mustDoThingsObj}
            setMustDoThingsObj={setMustDoThingsObj}
            isEditMustDoThings={isEditMustDoThings}
          />
        )}
        <DeleteModel
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          onConfirm={confirmDelete}
          title="Confirm Deletion"
          message="Are you sure you want to delete this MustDoThings?"
        />
      </Box>
    </>
  );
}

export default MustDoThings;